import React from "react";
const SupplyManageContext = React.createContext();
export default SupplyManageContext;
